import React from "react";
import { Grid, Typography } from "@mui/material";
import { getCardLogo } from "../../../utils/GetCardLogo";


export default function DefaultPayment(props: any) {
	return (
		<Grid container justifyContent="center" direction="column">
			<Grid>
				<Typography variant="subtitle1" align="center">
					<strong>We Accept:</strong>
				</Typography>
			</Grid>
			<Grid container justifyContent="center" spacing={1}>
				{props.acceptedCards?.map((card: any) => (
					<Grid key={card}>
						<img src={getCardLogo(card)} height={40} alt="card" />
					</Grid>
				))}
			</Grid>
		</Grid>
	);
}
